import { useIntl } from 'react-intl';
import * as Styled from './LoginPage.styled';
import { ExternalLoginPanel } from './ExternalLoginPanel';

interface AdmSamlLoginProps {
  readonly allowSaml2Login: boolean;
  readonly samlDescription: string;
  readonly returnTo?: string;
  readonly signInOrderList: string[];
}

export const AdmSamlLogin = ({ allowSaml2Login, samlDescription, returnTo, signInOrderList }: AdmSamlLoginProps) => {
  const intl = useIntl();
  const hasSamlInOrder = signInOrderList.includes('samlv2');

  if (!hasSamlInOrder || !allowSaml2Login) {
    return (
      <p>{intl.formatMessage({ id: 'signInNotConfigured', defaultMessage: 'Sign in process is not configured.' })}</p>
    );
  }

  return (
    <Styled.AllLoginTypeLayout>
      <Styled.FormsContainer id="loginFormsContainer" style={{ width: 'auto' }}>
        <ExternalLoginPanel panelId="organisationLogin" description={samlDescription}>
          <Styled.PanelLink href={returnTo ? `/samlc/login?returnTo=${returnTo}` : '/samlc/login'}>
            {intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' })}
          </Styled.PanelLink>
        </ExternalLoginPanel>
      </Styled.FormsContainer>
    </Styled.AllLoginTypeLayout>
  );
};
